import barba from '@barba/core';
import vars from '../helpers';
import carousel from '../vendor/owl.carousel';
import homeVideo from './home-video';
import articleVideos from './article-videos';
import homepageAnimations from './animations/homepage';
import scrollAnimation from './animations/scroll-animation';
import header from '../components/header';
import scroller from './scroller';
import social from '../components/social';
import analytics from './analytics';
import global from '../globals';

const body = vars.$body;

function delayFn(t = 2000) {
	return new Promise((done) => {
		setTimeout(() => {
			done();
		}, t);
	});
}

const enter = (data) => {
	const page = data.next.namespace;
	social.init();
	social.init();
	scrollAnimation.init();
	articleVideos.init(data.next.container);

	vars.isScreen.isMobile(() => {
		vars.scrollTo($('body'), 0);
	});

	if (global.scroller) {
		vars.isScreen.isDesktop(() => {
			const scrollbar = scroller.init(data.next.container);
			scrollbar.scrollTo(0, 0);
		});
	}

	let interval = null;

	if (page !== 'home') {
		body.removeClass('is-homepage').addClass('is-article');
		carousel.init().then(() => {
			setTimeout(carousel.addFirst, 200);
		});
		header.scrollToMainDestroy();
		homeVideo.destroy();

		if (interval) {
			clearInterval(interval);
		}
	} else {
		body.addClass('is-homepage').removeClass('is-article');
		const player = homeVideo.init();
		carousel.destroy();
		homepageAnimations();
		header.scrollToMainInit();

		player.on('playing', (event) => {
			const title = event.detail.plyr.config.title;

			ga('send', 'event', 'video', 'play', title, {nonInteraction: true});
			ga('rbcspec.send', 'event', 'video', 'play', {nonInteraction: true});

			interval = setInterval(() => {
				ga('send', 'event', 'video', 'timing 30s', title, 30);
				ga('rbcspec.send', 'event', 'video', 'timing 30s', '', 30);
			}, 30000);
		});

		player.on('ended', (event) => {
			const title = event.detail.plyr.config.title;
			ga('send', 'event', 'video', 'finish', title);
			ga('rbcspec.send', 'event', 'video', 'finish');

			clearInterval(interval);
		});

		player.on('pause', () => {
			clearInterval(interval);
		});
	}
};

barba.init({
	transitions: [{
		async leave() {
			const done = this.async();
			body.addClass('is-animated');
			await delayFn(600);
			done();
		},
		enter,
		afterEnter() {
			body.removeClass('is-animated');
		},
		once: enter,
	}],
	preventRunning: true,
	logLevel: 'error',
});

barba.hooks.leave((page) => {
	articleVideos.destroy();
	analytics.virtualHit(page.next.url.path);
	analytics.start15SecTimeout();
	jQuery.scrollDepth.reset();
	vars.isScreen.isDesktop(scroller.analyticScrollReset);
});

analytics.start15SecTimeout();
